<template>
    <div class="query-record">
        <el-card class="box-card flex-1 marginT-20">
            <div slot="header" class="flex">
                <span class="fw-bold fc-333">查询记录</span>
                <span style='font-size: 12px; padding-left: 6px; color: #F56C6C;'>（扫码成功后，点击历史详情查询历史数据不再收费；且72小时内免费查询最新数据，超过72小时则另行收费）</span>
            </div>
            <div>
                <div class="table">
                    <el-table :data="tableDataInfo" border>
                        <el-table-column prop="name" label="抖音账号称呼"></el-table-column>
                        <el-table-column label="性别">
                            <template slot-scope='scope'>
                                <span>{{dyCheckInfo.sex[scope.row.sex]}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="头像">
                            <template slot-scope='scope'>
                                <img style='width: 50px; height: 50px;' :src='scope.row.avatar' alt='avatar' />
                            </template>
                        </el-table-column>
                        <el-table-column prop="province" label="所属省"></el-table-column>
                        <el-table-column prop="city" label="所属市"></el-table-column>
                        <el-table-column prop="country" label="注册国家"></el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope='scope'>
                                <div>
                                    <el-button type='text' @click='historicalDetails(scope.row)'>历史详情</el-button>
                                </div>
                                <div>
                                    <el-button type='text' :loading='newLoading' @click='latestData(scope.row)'>最新数据</el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pages marginT-20 text-center">
                    <el-pagination
                        @current-change="handleCurrentChange"
                        :current-page="page"
                        :page-size="5"
                        layout="total, prev, pager, next, jumper"
                        :total="total"
                    ></el-pagination>
                </div>
            </div>
        </el-card>
        <info-dialog v-if='infoDialog.show' v-model='infoDialog.show' :info-data='infoDialog.infoData'></info-dialog>
    </div>
</template>

<script>
import pagination from '@/index/mixin/pagination'
import InfoDialog from '../_dialog/InfoDialog'
import { dyCheckInfo } from '../../../config'

export default {
    mixins: [pagination],
    components: {
        InfoDialog,
    },
    data() {
        return {
            dyCheckInfo,
            searchForm: {
                invokeName: 'tiktokcheck',
                psize: 5,
            },
            tableData: [],
            tableUrl: '/tool/accounts/invoke-log',
            qrDialog: false,
            infoDialog: {
                show: false,
                infoData: {},
            },
            newLoading: false,
        }
    },
    computed: {
        tableDataInfo() {
            return this.tableData.map(item => {
                try {
                    // let infoData = JSON.parse(item.result_data.info_data);
                    let infoData = item.result_data.info_data;
                    return {
                        id: item.id,
                        douyin_mark: item.result_data.douyin_mark,
                        ...infoData,
                    }
                } catch (e) {
                    console.log({ e });
                }
            });
        }
    },
    methods: {
        // 历史详情
        historicalDetails(row) {
            this.infoDialog.infoData = { ...row }
            this.infoDialog.show = true;
        },

        // 最新数据
        async latestData(row) {
            console.log({row})
            try {
                this.newLoading = true;
                const res = await this.$fetch('tool/accounts/tiktok-newest-info', {
                    id: row.id
                }, 'get')

                if (res.code === 0) {
                    let info = res.data;

                    this.infoDialog.infoData = {
                        douyin_mark: info.douyin_mark,
                        ...info.info_data
                    }
                    this.infoDialog.show = true;
                }
            } finally {
                this.newLoading = false;
            }
        },
    },
    mounted() {
        if (localStorage.token) {
            this.init()
        }

    },
    watch: {
        method(newValue, oldValue) {
            if (newValue) {
                this.searchForm.invokeName = newValue
            }
        }
    },
}
</script>

<style lang="scss" scoped>
</style>
